import axios from 'axios';
var axiosClient = null;
var Config = require('./config.json');

const apiClient = axios.create({
  baseURL: Config.api,
  withCredentials: false, //This is the default
  headers: {
    Accept: 'application/json'
  }
});

export default {
  getApiClient() {
    if (axiosClient) {
      axiosClient.defaults.headers.common['Authorization'] = axios.defaults.headers.common['Authorization']; // make sure the auth header is up to date
    } else {
      axiosClient = axios.create({
        baseURL: baseURL,
        headers: {
          Accept: 'application/json'
        },
        withCredentials: true
      });
    }
    return axiosClient;
  },
  setAxiosDefaults(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },
  getAll() {
    return apiClient.get('/getAll');
  },
  getFocusEntity(NAS_ID) {
    return apiClient.get('/getFocusEntity/' + NAS_ID);
  },
  getDefinitions() {
    return apiClient.get('/getDefinitions');
  },
  getDefinitionswAuth() {
    return apiClient.get('/getDefinitionswAuth');
  },
  //use the NAS_ID key as parameter for this route to be used on FocusEntity component
  getNas(NAS_ID) {
    return apiClient.get('/getNas/' + NAS_ID);
  },
  getNasPlain(NAS_ID) {
    return apiClient.get('/getNasPlain/' + NAS_ID);
  },
  
  updateNas(theData) {
    return apiClient.post('/postNas', theData);
  },

  //Used for full GCES PAGE
  getNasPDF(NAS_ID) {
    return apiClient.get('/getNasPdf?nasid='+ NAS_ID);
  },
  getAppearancePDF(NAS_ID) {
    return apiClient.get('/getAppearance?nasid='+ NAS_ID);
  },
  getDistinctEPDF(NAS_ID) {
    return apiClient.get('/getDistinctEntity?nasid='+ NAS_ID);
  },
  getExtractionCPDF(NAS_ID) {
    return apiClient.get('/getExtractionCriteria?nasid='+ NAS_ID);
  },
  getDelineationGPDF(NAS_ID) {
    return apiClient.get('/getDelineationGuidance?nasid='+ NAS_ID);
  },
  getExtractionGPDF(NAS_ID) {
    return apiClient.get('/getExtractionGuidance?nasid='+ NAS_ID);
  },
  getAttributionGPDF(NAS_ID) {
    return apiClient.get('/getAttributionGuidance?nasid='+ NAS_ID);
  },
  getImagesPDF(NAS_ID) {
    return apiClient.get('/q?nasid='+ NAS_ID);
  },
  

  getAppearance(NAS_ID) {
    return apiClient.get('/getAppearance/' + NAS_ID);
  },
  getAppearancePlain(NAS_ID) {
    return apiClient.get('/getAppearancePlain/' + NAS_ID);
  },
  countAppearExGuid(theData){
    return apiClient.post('/apeg', theData);
  },
  newAppearExGuid(theData){
    return apiClient.put('/app', theData);
  },
  updateAppearExGuid(theData){
    return apiClient.post('/app', theData);
  },
  removeAppearExGuid(theData){
    return apiClient.delete('/app', {data: theData});
  },

  putAppearance(theData){
    return apiClient.put('/app', theData);
  },

  getDistinctE(NAS_ID) {
    return apiClient.get('/getDistinctEntity/' + NAS_ID);
  },
  getUniqueID(NAS_ID) {
    return apiClient.get('/getUniqueID/' + NAS_ID);
  },
  getName(NAS_ID) {
    return apiClient.get('/getName/' + NAS_ID);
  },
  removeDistinctE(theData) {
    return apiClient.delete('/de', {data: theData});
  },
  newDistinctE(theData) {
    return apiClient.put('/de', theData);
  },
  getExtractionC(NAS_ID) {
    return apiClient.get('/getExtractionCriteria/' + NAS_ID);
  },
  newExtractCritAndDelGuid(theData) {
    return apiClient.put('/ecdg', theData);
  },
  updateExtractCritAndDelGuid(theData) {
    console.log(theData);
    return apiClient.post('/ecdg', theData);
  },
  removeExtractCritAndDelGuid(theData) {
    return apiClient.delete('/ecdg', {data: theData});
  },
  countExtractCritAndDelGuid(theData) {
    return apiClient.post('/cecdg', theData);
  }, 
  getExtractionG(NAS_ID) {
    return apiClient.get('/getExtractionGuidance/' + NAS_ID);
  },
  getExtractionGPlain(NAS_ID) {
    return apiClient.get('/getExtractionGuidancePlain/' + NAS_ID);
  },
  getDelineationG(NAS_ID) {
    return apiClient.get('/getDelineationGuidance/' + NAS_ID);
  },
  getAttributeG(NAS_ID) {
    return apiClient.get('/getAttributionGuidance/' + NAS_ID);
  },
  getAttributeGPlain(NAS_ID) {
    return apiClient.get('/getAttributionGuidancePlain/' + NAS_ID);
  },
  newAttributeG(theData) {
    return apiClient.put('/ag', theData);
  },
  updateAttributeG(theData) {
    return apiClient.post('/ag', theData);
  },
  deleteAttributeG(theData) {
    return apiClient.delete('/ag', {data: theData});
  },
  countAttributeG(theData) {
    return apiClient.post('/cag', theData);
  },
  getImages(NAS_ID) {
    return apiClient.get('/q/' + NAS_ID);
  },
  updateImage(imgInfo) {
    return apiClient.post('/qq', imgInfo);
  },
  newImage(imgInfo) {
    return apiClient.put('/qq', imgInfo);
  },
  removeImage(imgInfo) {
    return apiClient.delete('/qq', {data: imgInfo});
  },
  getTM() {
    return apiClient.get('/dps/getTM');
  },
  getTMImages() {
    return apiClient.get('/dps/getTMImages');
  },
  getDPSTMSymbolDetails(_ID) {
    return apiClient.get('/dps/getTMSymbolDetails/'+ _ID);
  },
  getDPSTMSymbolRules(_ID) {
    return apiClient.get('/dps/getTMSymbolRules/'+ _ID);
  },
  getDPSTMSymbolComponents(_ID) {
    return apiClient.get('/dps/getTMSymbolComponents/'+ _ID);
  },
  getDPSTMLabelRules(_ID) {
    return apiClient.get('/dps/getTMLabelRules/'+ _ID);
  },
  getDPSTMFinishingRules(_ID) {
    return apiClient.get('/dps/getTMFinishingRules/'+ _ID);
  },
  getDPSTMFinishingRuleDefs(Rule_ID) {
    return apiClient.get('/dps/getTMFinishingRuleDefs/'+ Rule_ID);
  },
  getTMAnA1() {
    return apiClient.get('/dps/getTMAnA1');
  },
  getTMACAnA() {
    return apiClient.get('/dps/getTMACAnA');
  },
  getTMACAnAMeta( _ID) {
    return apiClient.get('/dps/getTMACAnAMeta/'+ _ID);
  },
  getTMACAnAMain( _ID) {
    return apiClient.get('/dps/getTMACAnAMain/'+ _ID);
  },
  getTMACAnAMainAnnoRule( _ID) {
    return apiClient.get('/dps/getTMACAnAMainAnnoRule/'+ _ID);
  },
  getTMACAnAAnnoRules( _ID) {
    return apiClient.get('/dps/getTMACAnAAnnoRules/'+ _ID);
  },
  getTMACAnAVerRules( _ID) {
    return apiClient.get('/dps/getTMACAnAVersionRules/'+ _ID);
  },
  getTMACAnAComp( _ID) {
    return apiClient.get('/dps/getTMACAnAComp/'+ _ID);
  },
  getTMACAnASubTitles( _ID) {
    return apiClient.get('/dps/getTMACAnASubTitles/'+ _ID);
  },
  getTMAnA2() {
    return apiClient.get('/dps/getTMAnA2');
  },
  getTMAnB() {
    return apiClient.get('/dps/getTMAnB');
  },
  getTMAnC() {
    return apiClient.get('/dps/getTMAnC');
  },
  getTMAnD() {
    return apiClient.get('/dps/getTMAnD');
  },
  getTMAnE() {
    return apiClient.get('/dps/getTMAnE');
  },
  getTMAnF() {
    return apiClient.get('/dps/getTMAnF');
  },
  getTMAnG() {
    return apiClient.get('/dps/getTMAnG');
  },
  getTMAnH() {
    return apiClient.get('/dps/getTMAnH');
  },
  getTMAnI() {
    return apiClient.get('/dps/getTMAnI');
  },
  getTMAnJ() {
    return apiClient.get('/dps/getTMAnJ');
  },
  getTPCONC() {
    return apiClient.get('/dps/getTPCONC');
  },
  getTPCONCImages() {
    return apiClient.get('/dps/getTPCONCImages');
  },
  getTPCONCAnA1() {
    return apiClient.get('/dps/getTPCONCAnA1');
  },
  getTPCONCAnA2() {
    return apiClient.get('/dps/getTPCONCAnA2');
  },
  getTPCONCAnB() {
    return apiClient.get('/dps/getTPCONCAnB');
  },
  getTPCONCAnC() {
    return apiClient.get('/dps/getTPCONCAnC');
  },
  getTPCONCAnD() {
    return apiClient.get('/dps/getTPCONCAnD');
  },
  getTPCONCAnE() {
    return apiClient.get('/dps/getTPCONCAnE');
  },
  getTPCONCAnF() {
    return apiClient.get('/dps/getTPCONCAnF');
  },
  getTPCONCAnG() {
    return apiClient.get('/dps/getTPCONCAnG');
  },
  getTPCONCAnH() {
    return apiClient.get('/dps/getTPCONCAnH');
  },
  getTPCONCAnI() {
    return apiClient.get('/dps/getTPCONCAnI');
  },
  getTPCONCAnJ() {
    return apiClient.get('/dps/getTPCONCAnJ');
  },
  getDPSTPCSymbolDetails(_ID) {
    return apiClient.get('/dps/getTPCSymbolDetails/'+ _ID);
  },
  getDPSTPCSymbolRules(_ID) {
    return apiClient.get('/dps/getTPCSymbolRules/'+ _ID);
  },
  getDPSTPCSymbolComponents(_ID) {
    return apiClient.get('/dps/getTPCSymbolComponents/'+ _ID);
  },
  getDPSTPCLabelRules(_ID) {
    return apiClient.get('/dps/getTPCLabelRules/'+ _ID);
  },
  getDPSTPCFinishingRules(_ID) {
    return apiClient.get('/dps/getTPCFinishingRules/'+ _ID);
  },
  getDPSTPCFinishingRuleDefs(Rule_ID) {
    return apiClient.get('/dps/getTPCFinishingRuleDefs/'+ Rule_ID);
  },
  getTDSAttribute(NAS_ID) {
    return apiClient.get('/tds/getAttributeNameByID/' + NAS_ID);
  },
  getJOG() {
    return apiClient.get('/dps/getJOG');
  },
  getJOGImages() {
    return apiClient.get('/dps/getJOGImages');
  },
  getDPSJOGSymbolDetails(_ID) {
    return apiClient.get('/dps/getJOGSymbolDetails/'+ _ID);
  },
  getDPSJOGSymbolRules(_ID) {
    return apiClient.get('/dps/getJOGSymbolRules/'+ _ID);
  },
  getDPSJOGSymbolComponents(_ID) {
    return apiClient.get('/dps/getJOGSymbolComponents/'+ _ID);
  },
  getDPSJOGLabelRules(_ID) {
    return apiClient.get('/dps/getJOGLabelRules/'+ _ID);
  },
  getDPSJOGFinishingRules(_ID) {
    return apiClient.get('/dps/getJOGFinishingRules/'+ _ID);
  },
  getDPSJOGFinishingRuleDefs(Rule_ID) {
    return apiClient.get('/dps/getJOGFinishingRuleDefs/'+ Rule_ID);
  },
  getJOGAnA1() {
    return apiClient.get('/dps/getJOGAnA1');
  },
  getJOGAnA2() {
    return apiClient.get('/dps/getJOGAnA2');
  },
  getJOGAnB() {
    return apiClient.get('/dps/getJOGAnB');
  },
  getJOGAnC() {
    return apiClient.get('/dps/getJOGAnC');
  },
  getJOGAnD() {
    return apiClient.get('/dps/getJOGAnD');
  },
  getJOGAnE() {
    return apiClient.get('/dps/getJOGAnE');
  },
  getJOGAnF() {
    return apiClient.get('/dps/getJOGAnF');
  },
  getJOGAnG() {
    return apiClient.get('/dps/getJOGAnG');
  },
  getJOGAnH() {
    return apiClient.get('/dps/getJOGAnH');
  },
  getJOGAnI() {
    return apiClient.get('/dps/getJOGAnI');
  },
  getJOGAnJ() {
    return apiClient.get('/dps/getJOGAnJ');
  },
  getJOGACAnA() {
    return apiClient.get('/dps/getJOGACAnA');
  },
  getJOGACAnAMeta( _ID) {
    return apiClient.get('/dps/getJOGACAnAMeta/'+ _ID);
  },
  getJOGACAnAMain( _ID) {
    return apiClient.get('/dps/getJOGACAnAMain/'+ _ID);
  },
  getJOGACAnAMainAnnoRule( _ID) {
    return apiClient.get('/dps/getJOGACAnAMainAnnoRule/'+ _ID);
  },
  getJOGACAnAAnnoRules( _ID) {
    return apiClient.get('/dps/getJOGACAnAAnnoRules/'+ _ID);
  },
  getJOGACAnAVerRules( _ID) {
    return apiClient.get('/dps/getJOGACAnAVersionRules/'+ _ID);
  },
  getJOGACAnAComp( _ID) {
    return apiClient.get('/dps/getJOGACAnAComp/'+ _ID);
  },
  getJOGACAnASubTitles( _ID) {
    return apiClient.get('/dps/getJOGACAnASubTitles/'+ _ID);
  },

  //EVC
  getEVC() {
    return apiClient.get('/dps/getEVC');
  },
  getEVCImages() {
    return apiClient.get('/dps/getEVCImages');
  },
  getDPSEVCSymbolDetails(_ID) {
    return apiClient.get('/dps/getEVCSymbolDetails/'+ _ID);
  },
  getDPSEVCSymbolRules(_ID) {
    return apiClient.get('/dps/getEVCSymbolRules/'+ _ID);
  },
  getDPSEVCSymbolComponents(_ID) {
    return apiClient.get('/dps/getEVCSymbolComponents/'+ _ID);
  },
  getDPSEVCLabelRules(_ID) {
    return apiClient.get('/dps/getEVCLabelRules/'+ _ID);
  },
  getDPSEVCFinishingRules(_ID) {
    return apiClient.get('/dps/getEVCFinishingRules/'+ _ID);
  },
  getDPSEVCFinishingRuleDefs(Rule_ID) {
    return apiClient.get('/dps/getEVCFinishingRuleDefs/'+ Rule_ID);
  },
  getEVCAnB1() {
    return apiClient.get('/dps/getEVCAnB1');
  },
  getEVCAnB2() {
    return apiClient.get('/dps/getEVCAnB2');
  },
  getEVCAnB() {
    return apiClient.get('/dps/getEVCAnB');
  },
  getEVCAnC() {
    return apiClient.get('/dps/getEVCAnC');
  },
  getEVCAnD() {
    return apiClient.get('/dps/getEVCAnD');
  },
  getEVCAnE() {
    return apiClient.get('/dps/getEVCAnE');
  },
  getEVCAnF() {
    return apiClient.get('/dps/getEVCAnF');
  },
  getEVCAnG() {
    return apiClient.get('/dps/getEVCAnG');
  },
  getEVCAnH() {
    return apiClient.get('/dps/getEVCAnH');
  },
  getEVCAnI() {
    return apiClient.get('/dps/getEVCAnI');
  },
  getEVCAnJ() {
    return apiClient.get('/dps/getEVCAnJ');
  },
  getEVCAnN() {
    return apiClient.get('/dps/getEVCAnN');
  },


  getAttributeEnumerate(NAS_ID) {
    return apiClient.get('/tds/getAttributeEnumerateByID/' + NAS_ID);
  },
  getTdsMagAttribute(NAS_ID) {
    return apiClient.get('/tds/getTDSMAGAttributeNameByID/' + NAS_ID);
  },
  getMagEnumAttribute(NAS_ID) {
    return apiClient.get('/tds/getMAGAttributeEnumerateByID/' + NAS_ID);
  },
  getOsmMagTDSAttribute(NAS_ID) {
    return apiClient.get('/tds/getOSMMAGAttributeNameByID/' + NAS_ID);
  },
  //GEOAxIS
  // getUserRoles() {
  //   return this.getApiClient().get('/UserRoles')
  // },
  getApiBaseUrl() {
    return apiBaseUrl;
  },
  // getUserByGxID(id) {
  //   return this.getApiClient().get('/UserProfileByGxID/' + id)
  // },
  checkAdminStatus(id) {
    return apiClient.get('/getAdminStatus/' + id);
  },

  async getUserInfo() {
    const result = await this.getApiClient().get('/auth/userinfo', {
      baseURL: baseURL,
      withCredentials: true
    });
    return result.data;
  },
  // async getUserInfo() {
  //   const result = await otherApiClient.get('/auth/userinfo');
  //   console.log(result.data);
  //   return result.data;
  // },


  imageSource: Config.s3,
  imageSourceDps: Config.s3Dps,
  downloadSource: Config.s3Downloads,
  tpconcSymbolImages: Config.tpconcSymbolImages,
  tmSymbolImages: Config.tmSymbolImages,
  jogSymbolImages: Config.jogSymbolImages,
  evcSymbolImages: Config.evcSymbolImages
};
